import React, { useEffect, useState } from 'react';
const NAMES = ['Katrin', 'Sarah', 'Julia', 'Anna', 'Emma', 'Olivia', 'Charlotte', 'Mia', 'Chloe', 'Grace', 'Ruby', 'Sophie', 'Isla', 'Zoe', 'Lily', 'Michael'];
const CITIES = ['Sydney 🇦🇺', 'Melbourne 🇦🇺', 'Brisbane 🇦🇺', 'Perth 🇦🇺', 'Adelaide 🇦🇺', 'Gold Coast 🇦🇺', 'Canberra 🇦🇺', 'Newcastle 🇦🇺', 'Hobart 🇦🇺', 'Darwin 🇦🇺', 'Byron Bay 🇦🇺', 'Cairns 🇦🇺', 'Wollongong 🇦🇺', 'Geelong 🇦🇺'];
const PRODUCTS = [{
  name: 'Yoga Ready Kit + Specialist Manual',
  emoji: '🏆'
}, {
  name: 'Yoga Ready — The Complete Kit',
  emoji: '🧘‍♀️'
}];
const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
interface NotificationData {
  name: string;
  initial: string;
  city: string;
  product: {
    name: string;
    emoji: string;
  };
  timeAgo: number;
}
function generateRandomNotification(): NotificationData {
  const name = NAMES[Math.floor(Math.random() * NAMES.length)];
  const initial = LETTERS[Math.floor(Math.random() * LETTERS.length)];
  const city = CITIES[Math.floor(Math.random() * CITIES.length)];
  const product = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
  const timeAgo = Math.floor(Math.random() * 14) + 2;
  return {
    name,
    initial,
    city,
    product,
    timeAgo
  };
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [notification, setNotification] = useState<NotificationData | null>(null);
  useEffect(() => {
    if (isDismissed) return;
    let showTimeout: ReturnType<typeof setTimeout>;
    let hideTimeout: ReturnType<typeof setTimeout>;
    const cycleNotification = () => {
      setNotification(generateRandomNotification());
      setIsVisible(true);
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
        const nextDelay = 45000 + Math.floor(Math.random() * 30000);
        showTimeout = setTimeout(cycleNotification, nextDelay);
      }, 4000);
    };
    const initialTimeout = setTimeout(cycleNotification, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [isDismissed]);
  if (isDismissed || !notification) return null;
  return <div className={`fixed top-4 right-4 sm:top-6 sm:right-6 z-50 transition-all duration-500 ease-in-out ${isVisible ? 'translate-y-0 opacity-100' : '-translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-245">
      <div className="bg-bg-alt/95 backdrop-blur-md border border-border-light rounded-2xl shadow-[0_10px_40px_rgba(90,70,120,0.2)] p-4 max-w-[300px] sm:max-w-[320px] relative pr-8" data-id="element-246">
        <button onClick={() => setIsDismissed(true)} className="absolute top-3 right-3 text-text-sec hover:text-text-main transition-colors p-1" aria-label="Close notification" data-id="element-247">
          ✕
        </button>

        <div className="flex items-center gap-3 mb-3" data-id="element-248">
          <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0 bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 flex items-center justify-center shadow-inner" data-id="element-249">
            <span className="text-sm drop-shadow-[0_0_5px_rgba(168,85,247,0.5)]" data-id="element-250">
              👤
            </span>
          </div>
          <span className="text-text-main text-sm font-bold" data-id="element-251">
            {notification.name} {notification.initial}.{' '}
            <span className="text-text-sec font-normal ml-1 text-xs" data-id="element-252">
              {notification.city}
            </span>
          </span>
        </div>

        <p className="text-text-main text-sm mb-2 leading-tight font-medium" data-id="element-253">
          Just purchased:{' '}
          <span className="text-primary font-bold" data-id="element-254">
            {notification.product.name}
          </span>{' '}
          {notification.product.emoji}
        </p>

        <div className="flex items-center gap-2 mt-3 pt-2 border-t border-border-light/50" data-id="element-255">
          <div className="w-2 h-2 bg-check-green rounded-full shadow-[0_0_8px_rgba(16,185,129,0.8)]" data-id="element-256"></div>
          <p className="text-text-sec text-[10px] font-bold uppercase tracking-wider" data-id="element-257">
            Verified purchase · {notification.timeAgo} min ago
          </p>
        </div>
      </div>
    </div>;
}